<div class="row my-row justify-content-md-center" style="padding-top: 40px;">
    <div class="col-sm-auto">
        <div class="card" style="width: 70rem; border-radius: 20px; margin: 20px;">
            <div class="card-header text-center">
                <h1>{{ "CONSENT.TITLE" | translate }}</h1>
            </div>
            <div class="row my-row no-gutters">
                    <div class="card-body">
                        <div id="info">
                            <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
                        </div>
                        <div class="mt-2">
                            <form *ngIf="consentForm" [formGroup]="consentForm" novalidate (ngSubmit)="revokeConsent(consentForm.value)">
                                <div class='form-group'>
                                    <p>{{ "CONSENT.INFO" | translate }} ({{ userService.currentUser.ps }}) {{ "CONSENT.INFO-BIS" | translate }}</p>
                                    <input type="text" class="form-control w-50" placeholder="{{ 'FORM.MAIL' | translate }}" formControlName="email" id="email">
                                </div>
                                <div class='form-group'>
                                    <button type="submit" class="btn btn-primary" [disabled]="!consentForm.valid">{{ "BUTTONS.VALIDATE" | translate }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>